import {
  GETList, 
  GETDetail,
  POSTWithToken,
  DELETEWithToken,
  PUTWithToken,
  GETAutoComplete,
} from "@/services/base-service";

const API_URL = "/api/leave-request/v1";

export const getLeaveRequest = (values) => {
  const url = `${API_URL}/list`;
  return GETList(url, values);
};

export function createLeaveRequest(values) {
  const url = `${API_URL}/create`;
  return POSTWithToken(url, values);
}

export function getLeaveRequestAutoComplete(query, extra) {
  const url = `${API_URL}/autoComplete`;
  return GETAutoComplete(url, query, extra);
}

export function getLeaveRequestDetail(id) {
  return GETDetail(API_URL, id);
}

export function editLeaveRequest(values) {
  const { id } = values;
  const url = `${API_URL}/${id}`;
  return PUTWithToken(url, values);
}

export function archiveLeaveRequest(id) {
  const url = `${API_URL}/${id}/soft`;
  return DELETEWithToken(url);
}

export function unarchiveLeaveRequest(id) {
  const url = `${API_URL}/${id}/unarchive`;
  return PUTWithToken(url);
}

export function deleteLeaveRequest(id) {
  const url = `${API_URL}/${id}`;
  return DELETEWithToken(url);
}

export function updateStatusToSubmit(id) {
  const url = `${API_URL}/${id}/submit`;
  return PUTWithToken(url, null);
}

export function updateStatusToApprove(id) {
  const url = `${API_URL}/${id}/approve`;
  return PUTWithToken(url, null);
}

export function updateStatusToCancel(id) {
  const url = `${API_URL}/${id}/cancel`;
  return PUTWithToken(url, null);
}

export function updateStatusToReject(id) {
  const url = `${API_URL}/${id}/reject`;
  return PUTWithToken(url, null);
}